import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { getRoundFromIdAtom } from "../getRoundFromIdAtom/getRoundFromIdAtom";

export const getHostIdAtom = atomFamily((roundId: string) => {
  return atom((get) => {
    const round = get(getRoundFromIdAtom(roundId));
    const hostId = round?.hostId;
    return hostId;
  });
});
